import { ContentLoadErrorBlockCombinedProps } from './types';

const usePresenter = (props: ContentLoadErrorBlockCombinedProps): ContentLoadErrorBlockCombinedProps => {
  return props;
};

export default usePresenter;
